<template>
	<div :style="'--table-main-color:'+mainColor" class="table-head-wrapper">
		<div
			v-for="heading in headings"
			:style="'--cols:'+heading.cols*colMultiplier"
			class="table-col-heading"
			:class="{sortable: heading.sortable}"
			@click="clickHeading(heading)"
		>
			<p>{{heading.text}}</p>
			<AppChevronIcon
				v-if="heading.sortable"
				:direction="heading.sortAsc === false ? 'down' : 'up'"
				color="white"
				class="chevron-icon-wrapper"
				:class="{'active': heading.active}"
				:size="10"
			/>
		</div>
	</div>
</template>

<script>
import AppChevronIcon from "@/shared/components/AppChevronIcon.vue";

export default {
	name: "AppTableHeading",
	data() {
		return {

		}
	},
	emits: ['changed-sort'],
	components: {AppChevronIcon},
	props: {
		headings: {
			type: Array,
			required: true,
			validator(value) {
				//also can have Bool item.sortable & item.sortAsc
				return value.every(item => item.text && item.cols);
			}
		},
		colMultiplier: {
			type: Number,
			default: 1,
		},
		mainColor: {
			type: String,
			default: 'rgb(7, 82, 163)',
		}
	},
	computed: {

	},
	methods: {
		clickHeading(heading) {
			if(!heading.sortable) { return }
			this.headings.forEach(item => {
				if (item === heading) {
					heading.sortAsc = heading.active ? !heading.sortAsc : true;
					heading.active = true;
				} else if(heading.sortable) {
					item.active = false;
					item.sortAsc = true;
				}
			});
			this.$emit('changed-sort', heading.hasOwnProperty("sortFieldName") ? heading.sortFieldName : heading.fieldName, heading.sortAsc);
		}
	}
}
</script>

<style lang="scss" scoped>
:root {
	--cols: 1;
	--l-cols: calc(var(--cols) * 1.5);
	--m-cols: calc(var(--cols) * 2);
	--s-cols: calc(var(--cols) * 3);
	--xs-cols: calc(var(--cols) * 6);
	--table-main-color: $primary;
}
.table-head-wrapper {
	display: flex;
	align-items: stretch;
}
.table-col-heading {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	width: calc(100% / 12 * var(--cols));
	max-width: calc(100% / 12 * var(--cols));
	min-width: calc(100% / 12 * var(--cols));
	min-height: 25px;
	position: relative;
	background-color: var(--table-main-color);
	padding: 5px;

	&.sortable { cursor: pointer; }
	&:not(:last-of-type) {
		&:after{
			content: "";
			position: absolute;
			top: 0;
			right: 0;
			width: 1px;
			height: 100%;
			background-color: rgba(255, 255, 255, 0.2);
		}
	}

	& * {
		pointer-events: none;
		user-select: none;
	}
	p {
		max-width: calc(100% - 16px);
		overflow-wrap: break-word;
		hyphens: auto;
		font-size: 12px;
		line-height: 16px;
		color: var(--color-txt-white);
	}
	.chevron-icon-wrapper {
		display: flex;
		position: absolute;
		right: 3px;
		top: 50%;
		transform: translateY(-50%);
		border-radius: 50%;
		background-color: var(--table-main-color);
		opacity: .4;

		&.active {
			opacity: 1;
		}
	}
	&:hover{
		.chevron-icon-wrapper {
			opacity: .6;

			&.active {
				opacity: 1;
			}
		}
	}
}
</style>